import i18n from "@/i18n";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    language: "en",
    sidebar: {
      minimized: false
    },
    pageSize: 10,
    utmPageSize: 10,
    pageSizeOptions: [10, 20, 50, 100, 500],
    utmPageSizeOptions: [10, 20, 50, 100, 500, 1000, 5000],
    accessList: ["account", "report"],
  },
  mutations: {
    updateLanguage(state, payload) {
      state.language = payload;
    },
    updateSidebarMinimized(state, payload) {
      state.sidebar.minimized = payload;
    },
    updatePageSize(state, payload) {
      state.pageSize = payload;
    },
    updateUTMPageSize(state, payload) {
      state.utmPageSize = payload;
    },
  },
  actions: {
    setLanguage(context, payload) {
      i18n.locale = payload;
      context.commit("updateLanguage", payload);
    },
    setSidebarMinimized(context, payload) {
      context.commit("updateSidebarMinimized", payload);
    },
    setPageSize(context, payload) {
      context.commit("updatePageSize", payload);
    },
    setUTMPageSize(context, payload) {
      context.commit("updateUTMPageSize", payload);
    },
  }
};
